import Vue from 'vue';
export default Vue.extend({
    props: {
        label: {
            type: String,
            default: 'Search',
        },
        solo: {
            type: Boolean,
            default: false,
        },
        dataCy: {
            type: String,
            default: undefined,
        },
    },
    data: () => {
        return {
            value: '',
        };
    },
    computed: {
        title() {
            return this.$route.meta.title;
        }
    },
    methods: {
        setValue(val) {
            this.value = val;
        },
    },
    render(createElement) {
        return createElement('v-text-field', {
            props: {
                appendIcon: 'search',
                clearable: true,
                hideDetails: true,
                label: this.label,
                singleLine: true,
                value: this.value,
                solo: this.solo,
            },
            on: {
                input: (event) => {
                    // clear cursor every search input
                    localStorage.setItem(`${this.title.toLowerCase()}_cursor`, JSON.stringify([]));
                    localStorage.setItem(`${this.title.toLowerCase()}_search_cursor`, JSON.stringify(event || null));
                    this.$emit('input', event);
                },
            },
            attrs: {
                'data-cy': this.dataCy,
            },
        });
    },
});
